import request from '@/utils/request'
// import qs from 'qs'
// 员工工资统计
// 查看所有
export const pageList = (getData) => {
  return request({
    url: '/project-members/pageList',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 月度批量更新扣款信息和改革补足额信息
export const updateMembersWagesInfo = (postData) => {
  return request({
    url: '/project-members/updateMembersWagesInfo',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 导出员工工资
export const downloadWelfare = (getData) => {
  return request({
    url: '/project-members/downWages',
    method: 'get',
    headers: {
      'content-type': 'application/x-www-form-urlencoded;'
    },
    params: getData,
    responseType: 'blob'
  })
}
//备份
export const saveBackups = (getData) => {
  return request({
    url: '/project-members/saveBackups',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 查看已确认的工资
export const queryBackups = (getData) => {
  return request({
    url: '/project-members/queryBackups',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}